var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMcdLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: " Icons / Menu Items / McD Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20 copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21556 1.71421C3.89758 1.71421 -0.000946045 12.9684 0 22.2856H3.05976C3.05976 12.5132 5.43029 3.70796 7.13598 3.70758C8.91526 3.7074 10.4746 9.69704 10.4746 21.1086H13.5302C13.5302 9.69704 15.0801 3.70758 16.8689 3.70758C18.5714 3.70758 20.9403 12.5149 20.9403 22.2856H24C23.9971 12.9603 20.1085 1.71307 16.7845 1.71421C13.9464 1.71516 12.4556 7.80121 12 11.1773C11.5479 7.80198 10.0577 1.71421 7.21556 1.71421Z",
    fill: "#FDC82F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcdLogo);
export default __webpack_public_path__ + "static/media/mcd_logo.43e90641c7777d2195aba43114e9bd01.svg";
export { ForwardRef as ReactComponent };